import * as React from 'react';
import MagicWandOutlined from './magic-wand-outlined';
import MagicWandFilled from './magic-wand-filled';
import type { IconCombinedProps } from './types';
const MagicWandCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <MagicWandFilled ref={ref} {...rest} />;
  }
  return <MagicWandOutlined ref={ref} {...rest} />;
});
export default MagicWandCombined;